import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from 'admin/../environments/environment';

export const credentialsInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  return next(request.clone({ withCredentials: true }));
};
